export const environment = {
  CAEndpoint: 'https://api-dev.tetherall.io/clinician/',
  USEndpoint: 'https://api-dev.tetherall.io/clinician/',
  googleMapsKey: 'AIzaSyBxq_NmYsxR4N0GRzITE4J7sfZ79Im_El0',
  buildNumber: "29898148",  
  versionNumber: "5.4.11",  
  environment_deploy: 'dev',
  raygunKey: '43wdWdJaHTd1ENpkAYZ53g',
  authKey: 'b428d92b-0d09-4779-b659-2d7e390f4eb5',
  cryptoKey: '615b33fe-b8e6-4b27-a060-7e35ce166b25',
  posthogToken: 'phc_mRbixOQM4BkdIj6YXKcg46lDqXy7XcsEmdSSZzFZfM66',
};
